export default __webpack_public_path__ + "static/media/white-bg-incorrect1.446dd32e.PNG";